module.exports = __webpack_public_path__ + "img/Evaluate Tests red.9f9a5f00.svg";